<script>
// import { required } from 'vuelidate/lib/validators'

import appConfig from '@src/app.config'
import axios from 'axios'


export default {
	props: {
		code: {
			type: String,
		}
	},
	data() {
		return {
		}
	},
	methods: {
		AWSOauth2Token() {
			let that = this
			let baseURL = appConfig.AWS.oauth2TokenURL || ""

			const params = new URLSearchParams()
			params.append('grant_type', 'authorization_code')
			params.append('client_id', appConfig.AWS.appClientID)
			params.append('redirect_uri', appConfig.AWS.redirectURI)
			params.append('code', that.code);

			let headers = {
				"Content-Type": "application/x-www-form-urlencoded",
				"Authorization": appConfig.AWS.authorization
			}
			axios.post(baseURL, params, { headers: headers } ).then((response) => {
				if (response.status === 200) {
					that.$store.state.id_token = response.data.id_token
					that.$store.state.access_token = response.data.access_token
					that.$store.state.refresh_token = response.data.refresh_token
					that.$store.state.expires_in = response.data.expires_in
					that.$store.state.token_type = response.data.token_type
				}
			})
		},
	},
	computed: {

	},
	mounted () {
		// this.$store.state.id_token = null
		this.AWSOauth2Token()
		this.$router.push('/')
	},
}
</script>

<template>
	<div>
	</div>
</template>
